<template>
  <LayoutPrimary>
    <ModalTenantUserSkillEditPrimary
      @create-skill="createTenantUserSkill"
      @delete-skill="deleteTenantUserSkill"
      @update-skill="updateTenantUserSkill"
    />
    <DialogRevokeCoeditPrimary
      @revoke-coedit="revokeTenantUserCoedit"
    />
    <div :style="style.container">
      <div :style="getHeaderContainerStyle">
        <SearchExpertBoxPrimary
          v-model="tags"
          placeholder="Search experts"
          @filled="searchBoxFilled = true"
          @unfilled="searchBoxFilled = false"
          @focus="searchBoxFocus = true"
          @unfocus="searchBoxFocus = false"
          @search-by-person-name="searchExpertByPersonName"
          @search-by-skill-name="searchExpertBySkillName"
          :style="getSearchBoxStyle"
        />
      </div>
      <div :style="style.innerContainer">
        <div :style="style.leftContainer">
          <Summary
            :tenant="tenant"
            :tenantDiagnose="tenantDiagnose"
            :tenantUser="tenantUser"
            :tenantUserDiagnose="tenantUserDiagnose"
            :style="style.summary"
          />
        </div>
        <div :style="style.centerContainer">
          <Tutorial
            v-if="isOnboarding"
            :style="style.tutorial"
          />
          <Survey
            v-if="isEnterprise && surveys.length > 0"
            :surveys="surveys"
            :style="style.survey"
          />
          <CardPrimary :style="style.skillsGraphCard">
            <HeaderMediumPrimary :style="style.skillHeader">
              My skills graph
            </HeaderMediumPrimary>
            <SkillsGraphWrapperPrimary
              :isViewingOwnPage="true"
              :graphHeight="410"
              :loadedTenantUserSkills="loadedTenantUserSkills"
              :tenantUser="tenantUser"
              :tenantUserSkills="tenantUserSkills"
              @add-skill="openModalToAddTenantUserSkill"
              @edit-skill="openModalToEditTenantUserSkill"
              :style="getSkillsGraphWrapperStyle"
            />
          </CardPrimary>
          <CoeditHistory
            v-if="(
              loadedTenantUserCoedits &&
              loadedTenantUserSkills &&
              (
                tenantUserCoedits.length > 0 ||
                tenantUserSkills.filter(elem => !elem.isApproved).length > 0
              )
                  )"
            :tenantUserCoeditCount="tenantUserCoeditCount"
            :tenantUserCoedits="tenantUserCoedits"
            :tenantUserSkills="tenantUserSkills"
            :visitor="tenantUser"
            :style="style.coeditHistory"
            @edit-skill="openModalToEditTenantUserSkill"
            @revoke-coedit="openDialogToRevokeTenantUserCoedit"
            @see-more-coedits="fetchTenantUserCoedits"
          />
        </div>
        <div :style="style.rightContainer">
          <UserInvitation
            v-if="isAdmin"
            :style="style.userInvitation"
          />
          <JoinList
            :isLoading="!loadedTenantUsers"
            :tenantUsers="tenantUsers"
            :style="style.joinList"
          />
        </div>
      </div>
    </div>
  </LayoutPrimary>
</template>

<script>
  import ApiExpert from '@js/api/expert'
  import ApiTenantDiagnose from '@js/api/tenant-diagnose'
  import ApiTenantUser from '@js/api/tenant-user'
  import ApiTenantUserCoedit from '@js/api/tenant-user-coedit'
  import ApiTenantUserDiagnose from '@js/api/tenant-user-diagnose'
  import ApiTenantUserSkill from '@js/api/tenant-user-skill'
  import ApiTenantUserSurvey from '@js/api/tenant-user-survey'
  import CardPrimary from '@modules/v2/card/card-primary'
  import CoeditHistory from '@home/modules/coedit-history'
  import DialogRevokeCoeditPrimary from '@dialogs/dialog-revoke-coedit-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import HttpStatus from 'http-status-codes'
  import JoinList from '@home/modules/join-list'
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import ModalTenantUserSkillEditPrimary
    from '@modals/modal-tenant-user-skill-edit-primary'
  import SearchExpertBoxPrimary from '@modules/v2/input/search-expert-box-primary'
  import SkillsGraphWrapperPrimary
    from '@modules/v2/skills/skills-graph-wrapper-primary'
  import Summary from '@home/modules/summary'
  import Survey from '@home/modules/survey'
  import Tutorial from '@home/modules/tutorial'
  import UserInvitation from '@home/modules/user-invitation'
  import {
    DIALOG_NAMES,
    MODAL_WINDOW_NAMES,
    PAGE_SIZES,
    SEARCH_EXPERT_PARAMS,
    Z_INDEXES,
  } from '@js/constants'
  import { getTenantUserSkillEdges } from '@js/skill-utils'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'HomeView',
    components: {
      CardPrimary,
      CoeditHistory,
      DialogRevokeCoeditPrimary,
      HeaderMediumPrimary,
      JoinList,
      LayoutPrimary,
      ModalTenantUserSkillEditPrimary,
      SearchExpertBoxPrimary,
      SkillsGraphWrapperPrimary,
      Summary,
      Survey,
      Tutorial,
      UserInvitation,
    },
    data: function () {
      return {
        loadedTenantUserCoedits: false,
        loadedTenantUsers: false,
        loadedTenantUserSkills: false,
        searchBoxFilled: false,
        searchBoxFocus: false,
        surveys: [],
        tags: [],
        tenantUserCoeditCount: 0,
        tenantUserCoeditPage: 1,
        tenantUserCoedits: [],
        tenantUsers: [],
        tenantUserSkills: [],
        style: {
          centerContainer: {
            display: 'flex',
            flex: 2,
            flexDirection: 'column',
            minWidth: '360px',
            padding: '0 12px',
          },
          coeditHistory: {
            margin: '12px 0',
          },
          container: {
            margin: Layout.container.primary.margin,
            maxWidth: Layout.container.primary.maxWidth,
            padding: `0 12px`,
            width: '100%',
          },
          innerContainer: {
            alignItems: 'flex-start',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            maxWidth: Layout.container.primary.maxWidth,
            width: '100%',
          },
          joinList: {
            margin: '12px 0',
          },
          leftContainer: {
            flex: 1,
            minWidth: '304px',
            padding: '0 12px',
          },
          rightContainer: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            margin: `0 0 ${Layout.space.md} 0`,
            minWidth: '304px',
            padding: `0 12px`,
          },
          skillHeader: {
            left: Layout.space.md,
            position: 'absolute',
            top: Layout.space.md,
          },
          skillsGraphCard: {
            height: '414px',
            margin: '12px 0',
            position: 'relative',
          },
          skillsGraphWrapper: {
            margin: '12px 0',
          },
          summary: {
            margin: '12px 0',
          },
          survey: {
            margin: '12px 0',
          },
          tutorial: {
            margin: '12px 0',
          },
          userInvitation: {
            margin: '12px 0',
          },
        },
      };
    },
    mounted: async function () {
      if (this.isEnterprise) {
        await this.fetchSurveys();
      }
      await this.fetchTenantUserSkills();
      await this.fetchTenantUsers();
      await this.fetchTenantUserCoedits();
      if (!this.tenantUserDiagnoseInitialized) {
        await this.fetchTenantUserDiagnose();
      }
      if (!this.tenantDiagnoseInitialized) {
        await this.fetchTenantDiagnose();
      }
    },
    computed: {
      ...mapGetters('tenant', ['isEnterprise']),
      ...mapGetters('tenantUser', ['isAdmin']),
      ...mapState({
        tenant: state => state.tenant,
        tenantDiagnose: state => state.tenantDiagnose.data,
        tenantDiagnoseInitialized: state => state.tenantDiagnose.initialized,
        tenantUser: state => state.tenantUser,
        tenantUserDiagnose: state => state.tenantUserDiagnose.data,
        tenantUserDiagnoseInitialized: state => state.tenantUserDiagnose.initialized,
      }),
      getHeaderContainerStyle: function () {
        return {
          alignItems: 'center',
          display: 'flex',
          height: '88px',
          maxWidth: this.searchBoxFocus || this.searchBoxFilled ? '480px' : '280px',
          padding: `${Layout.space.sm} 12px 0`,
          width: '100%',
        };
      },
      getSearchBoxStyle: function () {
        return {
          flex: 1,
          zIndex: Z_INDEXES.HOME.SEARCH_BOX,
        };
      },
      getSkillsGraphWrapperStyle: function () {
        return {
          borderRadius: Layout.space.sm,
          height: '100%',
          width: '100%',
        };
      },
      isOnboarding: function () {
        return this.loadedTenantUserSkills && this.tenantUserSkills.length === 0;
      },
      tenantUserSkillEdges: function () {
        return getTenantUserSkillEdges(this.tenantUserSkillNodes);
      },
      tenantUserSkillNodes: function () {
        return this.tenantUserSkills.reduce((result, elem) => {
          result.push({
            ...elem,
            name: elem.skill.name,
          });
          return result;
        }, []);
      },
    },
    methods: {
      createTenantUserSkill: async function (form) {
        let tenantUserSkillId = form.params.id;

        try {
          this.loadedTenantUserSkills = await false;
          const payload = await form.getPostPayload();
          const api = await new ApiTenantUserSkill(this.tenantUser.id);
          const res=  await api.post(payload);
          await this.tenantUserSkills.push(res.data);
          tenantUserSkillId = await res.data.id;
        } catch (error) {
          console.error(error);
          if (error?.response?.status === HttpStatus.CONFLICT) {
            this.$store.commit(
              'notification/setWarning',
              'The skill is already registered'
            );
          } else {
            this.$store.commit(
              'notification/setWarning',
              'Failed to add skill',
            );
          }
        } finally {
          this.hideModalWindowToEditTenantUserSkill();
          this.loadedTenantUserSkills = true;
        }
      },
      deleteTenantUserSkill: async function (form) {
        try {
          this.loadedTenantUserSkills = await false;
          const tenantUserSkillId = await form.params.id;
          const api = await new ApiTenantUserSkill(
              this.tenantUser.id, tenantUserSkillId);
          const res = await api.delete();
          await this.removeTenantUserSkill(res.data.id);
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to delete skill',
          );
        } finally {
          this.hideModalWindowToEditTenantUserSkill();
          this.loadedTenantUserSkills = true;
        }
      },
      fetchSurveys: async function () {
        try {
          const api = await new ApiTenantUserSurvey(this.tenantUser.id);
          const query = await {
            page: 1,
            pageSize: 1,
          };
          const res = await api.get(query);
          this.surveys = await res.data.results;
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch surveys',
          );
        }
      },
      fetchTenantDiagnose: async function () {
        try {
          const api = await new ApiTenantDiagnose();
          const res = await api.get();
          await this.$store.commit('tenantDiagnose/set', res.data);
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch diagnose',
          );
        }
      },
      fetchTenantUserCoedits: async function () {
        try {
          const query = await {
            page: this.tenantUserCoeditPage,
            pageSize: PAGE_SIZES.TENANT_USER_COEDIT,
          };

          const api = await new ApiTenantUserCoedit(this.tenantUser.id);
          const res = await api.get(query);
          await this.tenantUserCoedits.push(...res.data.results);
          this.tenantUserCoeditCount = await res.data.count;
          if (this.tenantUserCoedits.length < this.tenantUserCoeditCount) {
            this.tenantUserCoeditPage++;
          }
          this.loadedTenantUserCoedits = await true;
        } catch (error) {
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to load coedits');
        }
      },
      fetchTenantUserDiagnose: async function () {
        try {
          const api = await new ApiTenantUserDiagnose(this.tenantUser.id);
          const res = await api.get();
          await this.$store.commit('tenantUserDiagnose/set', res.data);
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch user summary'
          );
        }
      },
      fetchTenantUsers: async function () {
        try {
          this.loadedTenantUsers = await false;

          const query = await {
            page: 1,
            pageSize: 5,
          };
          const api = await new ApiTenantUser();
          const res = await api.get(query);
          this.tenantUsers = await res.data.results;

          this.loadedTenantUsers = await true;
        } catch (error) {
          this.loadedTenantUsers = false;
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to load users');
        }
      },
      fetchTenantUserSkills: async function () {
        try {
          this.loadedTenantUserSkills = await false;

          const api = await new ApiTenantUserSkill(this.tenantUser.id);
          const res = await api.get();
          this.tenantUserSkills = await res.data;

          this.loadedTenantUserSkills = await true;
        } catch (error) {
          this.loadedTenantUserSkills = false;
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to load skills');
        }
      },
      hideModalWindowToEditTenantUserSkill: function () {
        this.$modal.hide(MODAL_WINDOW_NAMES.CONFIGURE_TENANT_USER_SKILL_PRIMARY);
      },
      openDialogToRevokeTenantUserCoedit: function (tenantUserSkill) {
        const params = {
          tenantUserSkill: tenantUserSkill,
        };
        this.$modal.show(DIALOG_NAMES.REVOKE_TENANT_USER_COEDIT_PRIMARY, params);
      },
      openModalToAddTenantUserSkill: function () {
        const params = {
          tenantUserSkill: null,
          tenantUserSkills: this.tenantUserSkills,
        };
        this.$modal.show(MODAL_WINDOW_NAMES.CONFIGURE_TENANT_USER_SKILL_PRIMARY, params);
      },
      openModalToEditTenantUserSkill: function (tenantUserSkill) {
        const params = {
          tenantUserSkill: tenantUserSkill,
          tenantUserSkills: this.tenantUserSkills,
        };
        this.$modal.show(MODAL_WINDOW_NAMES.CONFIGURE_TENANT_USER_SKILL_PRIMARY, params);
      },
      removeTenantUserSkill: function (tenantUserSkillId) {
        const index = this.tenantUserSkills.findIndex(
          elem => elem.id === tenantUserSkillId);
        if (index >= 0) {
          this.tenantUserSkills.splice(index, 1);
        }
      },
      removeTenantUserCoedit: function (tenantUserSkillId) {
        const index = this.tenantUserCoedits.findIndex(
          elem => elem.id === tenantUserSkillId);
        if (index >= 0) {
          this.tenantUserCoedits.splice(index, 1);
        }
      },
      revokeTenantUserCoedit: async function (tenantUserSkill) {
        try {
          const api = await new ApiTenantUserSkill(
            tenantUserSkill.tenantUser.id, tenantUserSkill.id);
          const res = await api.delete();
          await this.removeTenantUserCoedit(res.data.id);
          await this.$store.commit(
            'notification/setMessage',
            `Revoked ${tenantUserSkill.skill.name}`,
          );
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to revoke skill',
          );
        } finally {
          this.$modal.hide(DIALOG_NAMES.REVOKE_TENANT_USER_COEDIT_PRIMARY);
        }
      },
      searchExpertByPersonName: function (input) {
        this.$router.push({
          name: 'search',
          query: {
            by: SEARCH_EXPERT_PARAMS.MODE.BY_PERSON_NAME,
            tag: [input],
          },
        });
      },
      searchExpertBySkillName: function (tags) {
        this.$router.push({
          name: 'search',
          query: {
            by: SEARCH_EXPERT_PARAMS.MODE.BY_SKILL_NAME,
            tag: tags,
          },
        });
      },
      updateLocalTenantUserSkills: function (tenantUserSkill) {
        const sourceId = tenantUserSkill.id;

        this.tenantUserSkills = this.tenantUserSkills
          .reduce((result, elem) => {
            if (elem.id === sourceId) {
              elem = tenantUserSkill;
            } else {
              const deletedFromTargets = (
                elem.targets.includes(sourceId) &&
                !tenantUserSkill.targets.includes(elem.id)
              );
              const addedToTargets = (
                !elem.targets.includes(sourceId) &&
                tenantUserSkill.targets.includes(elem.id)
              );
              if (deletedFromTargets) {
                const index = elem.targets.findIndex(elem => elem === sourceId);
                elem.targets.splice(index, 1);
              } else if (addedToTargets) {
                elem.targets.push(sourceId);
              }
            }

            result.push(elem);
            return result;
          }, []
        );
      },
      updateTenantUserSkill: async function (form) {
        try {
          this.loadedTenantUserSkills = await false;
          const tenantUserSkillId = form.params.id;
          const payload = form.getPutPayload();
          const api = new ApiTenantUserSkill(
            this.tenantUser.id,
            tenantUserSkillId,
          );
          const res = await api.put(payload);
          this.updateLocalTenantUserSkills(res.data);
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to update skill',
          );
        } finally {
          this.hideModalWindowToEditTenantUserSkill();
          this.loadedTenantUserSkills = true;
        }
      },
    },
  };
</script>
